import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunks
export const fetchActivities = createAsyncThunk(
  'activities/fetchActivities',
  async (partnerId, { rejectWithValue }) => {
    try {
      // Simulate API call
      const response = await new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            partner_id: partnerId,
            total_activities: 45,
            activities: Array.from({ length: 15 }, (_, i) => ({
              id: `act_${i + 1}`,
              name: ['Tree Planting', 'Solar Installation', 'Water Conservation', 'Organic Farming', 'Waste Management'][i % 5],
              description: `Activity description for ${['Tree Planting', 'Solar Installation', 'Water Conservation', 'Organic Farming', 'Waste Management'][i % 5]}`,
              type: ['climate', 'education', 'health', 'livelihood'][Math.floor(Math.random() * 4)],
              status: ['active', 'completed', 'planned'][Math.floor(Math.random() * 3)],
              participants: Math.floor(Math.random() * 50) + 10,
              created_at: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString()
            }))
          });
        }, 1000);
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  activitiesData: null,
  isLoading: false,
  error: null,
  lastUpdated: null,
};

const activitiesSlice = createSlice({
  name: 'activities',
  initialState,
  reducers: {
    clearActivitiesError: (state) => {
      state.error = null;
    },
    addActivity: (state, action) => {
      if (state.activitiesData) {
        state.activitiesData.activities.unshift(action.payload);
        state.activitiesData.total_activities += 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchActivities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.activitiesData = action.payload;
        state.lastUpdated = Date.now();
        state.error = null;
      })
      .addCase(fetchActivities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearActivitiesError, addActivity } = activitiesSlice.actions;

// Selectors
export const selectActivities = (state) => state.activities;
export const selectActivitiesData = (state) => state.activities.activitiesData;
export const selectActivitiesLoading = (state) => state.activities.isLoading;
export const selectActivitiesError = (state) => state.activities.error;
export const selectTotalActivities = (state) => state.activities.activitiesData?.total_activities || 0;
export const selectActivitiesList = (state) => state.activities.activitiesData?.activities || [];

export default activitiesSlice.reducer;
